import api from './api';
import type { PantallaModularDto, PantallaModularCreateRequest } from '@/types/pantallaModular';

export const pantallaModularApi = {
  findAll: () =>
    api.get<PantallaModularDto[]>('/pantallas-modulares').then((r) => r.data),

  create: (data: PantallaModularCreateRequest) =>
    api.post<PantallaModularDto>('/pantallas-modulares', data).then((r) => r.data),

  update: (id: number, data: PantallaModularCreateRequest) =>
    api.put<PantallaModularDto>(`/pantallas-modulares/${id}`, data).then((r) => r.data),

  uploadImage: (id: number, formData: FormData) =>
    api.post<PantallaModularDto>(`/pantallas-modulares/${id}/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data),

  delete: (id: number) =>
    api.delete(`/pantallas-modulares/${id}`),
};
